import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  addPackage,
  fetchPackageById,
  fetchPackages,
  updatePackage,
  updateStatusInPkg,
} from "./thunk";

interface PackageState {
  packageList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedPackage: any;
}

const initialState: PackageState = {
  packageList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedPackage: null,
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.packageList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      })
      .addCase(fetchPackageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackageById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPackage = action.payload;
      })
      .addCase(fetchPackageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addPackage.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.packageList = state.packageList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(addPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add packages";
      })
      .addCase(updatePackage.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.packageList = state.packageList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(updatePackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update packages";
      })
      .addCase(updateStatusInPkg.fulfilled, (state, action) => {
        // if (!action.payload?.data.id) return;
        // state.packageList = state.packageList.map((pkg) =>
        //   pkg.id === action.payload.data.id ? action.payload.data : pkg
        // );
      })

      .addCase(updateStatusInPkg.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      });
  },
});

export default packageSlice.reducer;
